export default {
      id: "info_light-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#info_light",
      toString: function () {
        return this.url;
      }
    }